import { ReactElement, useContext } from "react";
import { Canvas } from "react-three-fiber";
import SettingsContext from "../../../contexts/SettingsContext";
import Space from "./Space";

/**
 * Type for props
 */
type propsType = {
  outer: ReactElement | false;
  inner: ReactElement | false;
  lives: number | false;
};

/**
 * Renders a background (space background with divs rendered on top)
 * @param props is the props
 * @returns html element of background
 */
const Background = (props: propsType) => {
  const settingsContext = useContext(SettingsContext);

  return (
    <div className="relative w-full h-full">
      {props.outer && (
        <div className="absolute top-0 left-0 w-full h-full z-50">
          {props.outer}
        </div>
      )}
      <Canvas style={{ backgroundColor: settingsContext.backgroundColor }}>
        <ambientLight intensity={0.35} />
        <directionalLight position={[0, 10, 0]} intensity={1.2} />
        {props.inner && props.inner}
        {Space()}
      </Canvas>
    </div>
  );
};

export default Background;
